// extracted by mini-css-extract-plugin
export default {"newsContainer":"NewsPage_newsContainer__hg-uD","newsImg":"NewsPage_newsImg__JZWg5","context":"NewsPage_context__XMfwd"};